// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rep-card {
    display: flex;
    padding: 17px 23px;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0px 4px 8px 3px rgba(0, 0, 0, 0.14);
    position: relative;
    height: 558px;
    width: 293px;
    transition: transform 0.1s ease-in-out;
    box-sizing: content-box;
    overflow: hidden;
    text-decoration: none !important;
    border: none;
}

.rep-card:hover {
    transform: scale(1.01);
}

.rep-card .image-wrapper {
    position: relative;
    height: 254px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    z-index: 2;
}

.rep-card .image-wrapper::after {
    content: none;
}

.rep-card .image-wrapper.republican::after {
    background: linear-gradient(0deg, rgba(236, 83, 114, 0.6) 0%, rgba(236, 83, 114, 0) 100%);
}

.rep-card .image-wrapper.democrat::after {
    background: linear-gradient(0deg, rgba(69, 139, 234, 0.6) 0%, rgba(69, 139, 234, 0) 100%);
}

.rep-card .image-wrapper.other::after {
    background: linear-gradient(0deg, rgba(160, 160, 160, 0.6) 0%, rgba(160, 160, 160, 0) 100%);
}

.rep-card .mask-group {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: 50% 20%;
    border-radius: 8px;
    position: relative;
    z-index: 1;
    border: none;
    box-shadow: none;
}

/* Remove these rules as they're no longer needed */
.rep-card::before,
.rep-card::after {
    content: none;
}

.rep-card .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 21px;
    position: relative;
    z-index: 2;
}

.rep-card .text-box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 7px;
}

.rep-card .text-wrapper {
    color: var(--gray, #393939);
    font-size: 24px;
    font-weight: 700;
    line-height: 24.539px;
    letter-spacing: -0.24px;
    word-break: break-word;
}

.rep-card .div {
    color: var(--gray, #393939);
    font-size: 18px;
    font-weight: 700;
    line-height: 24.539px;
    letter-spacing: -0.18px;
}

.rep-card .topics-container {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 10px;
}

.rep-card .topic {
    display: flex;
    padding: 12px 38px;
    justify-content: center;
    align-items: center;
    border-radius: 25.672px;
    background: #DFEBFC;
    color: #434343;
    font-size: 12.358px;
    font-style: normal;
    font-weight: 600;
    line-height: 13.29px; /* 158.999% */
    letter-spacing: 0.277px;
}

/* Add this rule to override any unintended text underlining */
.rep-card * {
    text-decoration: none;
}

/* Override link styles if RepCard is wrapped in a Router Link */
a .rep-card,
a:hover .rep-card,
a:visited .rep-card {
    text-decoration: none;
    color: inherit;
}

.rep-card,
.rep-card *,
.rep-card *::before,
.rep-card *::after {
    text-decoration: none !important;
}

.rep-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 30%; /* Adjust to 30% of the card height */
    z-index: 1;
    opacity: 0.4;
    pointer-events: none;
}

.rep-card.republican::before {
    background: linear-gradient(180deg, rgba(240, 106, 106, 0.9) 0%, rgba(123, 6, 30, 0) 70%);
}

.rep-card.democrat::before {
    background: linear-gradient(180deg, rgba(69, 139, 234, 0.9) 0%, rgba(69, 139, 234, 0) 70%);
}

.rep-card.other::before {
    background: linear-gradient(180deg, rgba(128, 128, 128, 0.6) 0%, rgba(128, 128, 128, 0) 70%);
}

.rep-card::after {
    content: '';
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    border: 3px solid transparent; /* Increased border thickness */
    border-radius: 4px;
    pointer-events: none;
}

@media (max-width: 1224px) {
    .rep-card {
        height: 366px;
        width: 200px;
        gap: 10px;
        box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.14);
    }

    .rep-card .mask-group {
        height: 180px;
    }

    /* Adjust hover effect for smaller screens */
    .rep-card.republican:hover,
    .rep-card.democrat:hover,
    .rep-card.other:hover {
        box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.14);
    }

    .rep-card::before {
        height: 180px;
    }

    .rep-card::after {
        top: 3px;
        left: 3px;
        right: 3px;
        bottom: 3px;
        border-width: 2px; /* Slightly thinner border for smaller screens */
    }

    .rep-card .topics-container {
        gap: 2px;
    }

    .rep-card .topic {
        padding: 6px 14px;
        font-size: 8.2px;
    }

    .rep-card .div {
        font-size: 10.575px;
        line-height: 14.416px;
        letter-spacing: -0.106px;
    }

    .rep-card .text-wrapper {
        font-size: 14.1px;
        line-height: 14.416px;
        letter-spacing: -0.141px;
    }

    .rep-card .image-wrapper {
        height: 180px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/RepCard/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,+CAA+C;IAC/C,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,sCAAsC;IACtC,uBAAuB;IACvB,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yFAAyF;AAC7F;;AAEA;IACI,yFAAyF;AAC7F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;;IAEI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB,EAAE,aAAa;IACnC,uBAAuB;AAC3B;;AAEA,8DAA8D;AAC9D;IACI,qBAAqB;AACzB;;AAEA,gEAAgE;AAChE;;;IAGI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;;;IAII,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW,EAAE,qCAAqC;IAClD,UAAU;IACV,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,yFAAyF;AAC7F;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,4FAA4F;AAChG;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,6BAA6B,EAAE,+BAA+B;IAC9D,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ,SAAS;QACT,+CAA+C;IACnD;;IAEA;QACI,aAAa;IACjB;;IAEA,4CAA4C;IAC5C;;;QAGI,+CAA+C;IACnD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,UAAU;QACV,WAAW;QACX,iBAAiB,EAAE,gDAAgD;IACvE;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".rep-card {\n    display: flex;\n    padding: 17px 23px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 30px;\n    border-radius: 8px;\n    background: #FFF;\n    box-shadow: 0px 4px 8px 3px rgba(0, 0, 0, 0.14);\n    position: relative;\n    height: 558px;\n    width: 293px;\n    transition: transform 0.1s ease-in-out;\n    box-sizing: content-box;\n    overflow: hidden;\n    text-decoration: none !important;\n    border: none;\n}\n\n.rep-card:hover {\n    transform: scale(1.01);\n}\n\n.rep-card .image-wrapper {\n    position: relative;\n    height: 254px;\n    width: 100%;\n    border-radius: 8px;\n    overflow: hidden;\n    z-index: 2;\n}\n\n.rep-card .image-wrapper::after {\n    content: none;\n}\n\n.rep-card .image-wrapper.republican::after {\n    background: linear-gradient(0deg, rgba(236, 83, 114, 0.6) 0%, rgba(236, 83, 114, 0) 100%);\n}\n\n.rep-card .image-wrapper.democrat::after {\n    background: linear-gradient(0deg, rgba(69, 139, 234, 0.6) 0%, rgba(69, 139, 234, 0) 100%);\n}\n\n.rep-card .image-wrapper.other::after {\n    background: linear-gradient(0deg, rgba(160, 160, 160, 0.6) 0%, rgba(160, 160, 160, 0) 100%);\n}\n\n.rep-card .mask-group {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    object-position: 50% 20%;\n    border-radius: 8px;\n    position: relative;\n    z-index: 1;\n    border: none;\n    box-shadow: none;\n}\n\n/* Remove these rules as they're no longer needed */\n.rep-card::before,\n.rep-card::after {\n    content: none;\n}\n\n.rep-card .content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 21px;\n    position: relative;\n    z-index: 2;\n}\n\n.rep-card .text-box {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 7px;\n}\n\n.rep-card .text-wrapper {\n    color: var(--gray, #393939);\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 24.539px;\n    letter-spacing: -0.24px;\n    word-break: break-word;\n}\n\n.rep-card .div {\n    color: var(--gray, #393939);\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 24.539px;\n    letter-spacing: -0.18px;\n}\n\n.rep-card .topics-container {\n    display: flex;\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.rep-card .topic {\n    display: flex;\n    padding: 12px 38px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 25.672px;\n    background: #DFEBFC;\n    color: #434343;\n    font-size: 12.358px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 13.29px; /* 158.999% */\n    letter-spacing: 0.277px;\n}\n\n/* Add this rule to override any unintended text underlining */\n.rep-card * {\n    text-decoration: none;\n}\n\n/* Override link styles if RepCard is wrapped in a Router Link */\na .rep-card,\na:hover .rep-card,\na:visited .rep-card {\n    text-decoration: none;\n    color: inherit;\n}\n\n.rep-card,\n.rep-card *,\n.rep-card *::before,\n.rep-card *::after {\n    text-decoration: none !important;\n}\n\n.rep-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 30%; /* Adjust to 30% of the card height */\n    z-index: 1;\n    opacity: 0.4;\n    pointer-events: none;\n}\n\n.rep-card.republican::before {\n    background: linear-gradient(180deg, rgba(240, 106, 106, 0.9) 0%, rgba(123, 6, 30, 0) 70%);\n}\n\n.rep-card.democrat::before {\n    background: linear-gradient(180deg, rgba(69, 139, 234, 0.9) 0%, rgba(69, 139, 234, 0) 70%);\n}\n\n.rep-card.other::before {\n    background: linear-gradient(180deg, rgba(128, 128, 128, 0.6) 0%, rgba(128, 128, 128, 0) 70%);\n}\n\n.rep-card::after {\n    content: '';\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    right: 5px;\n    bottom: 5px;\n    border: 3px solid transparent; /* Increased border thickness */\n    border-radius: 4px;\n    pointer-events: none;\n}\n\n@media (max-width: 1224px) {\n    .rep-card {\n        height: 366px;\n        width: 200px;\n        gap: 10px;\n        box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.14);\n    }\n\n    .rep-card .mask-group {\n        height: 180px;\n    }\n\n    /* Adjust hover effect for smaller screens */\n    .rep-card.republican:hover,\n    .rep-card.democrat:hover,\n    .rep-card.other:hover {\n        box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.14);\n    }\n\n    .rep-card::before {\n        height: 180px;\n    }\n\n    .rep-card::after {\n        top: 3px;\n        left: 3px;\n        right: 3px;\n        bottom: 3px;\n        border-width: 2px; /* Slightly thinner border for smaller screens */\n    }\n\n    .rep-card .topics-container {\n        gap: 2px;\n    }\n\n    .rep-card .topic {\n        padding: 6px 14px;\n        font-size: 8.2px;\n    }\n\n    .rep-card .div {\n        font-size: 10.575px;\n        line-height: 14.416px;\n        letter-spacing: -0.106px;\n    }\n\n    .rep-card .text-wrapper {\n        font-size: 14.1px;\n        line-height: 14.416px;\n        letter-spacing: -0.141px;\n    }\n\n    .rep-card .image-wrapper {\n        height: 180px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
